import { ConfigFn } from '@config/types'

const config = (({ publication, searchUrl }) =>
  ({
    apiUrl: `${searchUrl}/search`,
    sectionUrl: publication === 'romandie' ? '/fr/chercher/' : '/suche/',
  }) as const) satisfies ConfigFn

export default config
